import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderCompensationEntity } from '../../domain/entities/OrderCompensationEntity'

export class OrderCompensationModel extends OrderCompensationEntity {
  constructor(dataDto: OrderCompensationEntity) {
    super()
    mapEntityProperties<OrderCompensationEntity>(this, dataDto)
  }
}
